:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.range-nodes-list {
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  margin: 24px 0 0;
  padding: 0;
  overflow-y: hidden;
}

@media screen and (max-width: 979px) {
  .range-nodes-list {
    flex-direction: column;
  }
}

.range-nodes-list__item {
  margin-bottom: 20px;
}

:host(:not([dir="rtl"])) .range-nodes-list__item:not(:last-child) {
  margin-right: 20px;
}

:host([dir="rtl"]) .range-nodes-list__item:not(:last-child) {
  margin-left: 20px;
}

@media screen and (max-width: 979px) {
  .range-nodes-list__item:not(:last-child) {
    margin-bottom: 20px;
  }

  :host(:not([dir="rtl"])) .range-nodes-list__item:not(:last-child) {
    margin-right: auto;
  }

  :host([dir="rtl"]) .range-nodes-list__item:not(:last-child) {
    margin-left: auto;
  }
}

:host(:not([dir="rtl"])) .range-nodes-list__item:nth-child(4n) {
  margin-right: 0;
}

:host([dir="rtl"]) .range-nodes-list__item:nth-child(4n) {
  margin-left: 0;
}

@media screen and (max-width: 979px) {
  :host(:not([dir="rtl"])) .range-nodes-list__item:nth-child(4n) {
    margin-right: auto;
  }

  :host([dir="rtl"]) .range-nodes-list__item:nth-child(4n) {
    margin-left: auto;
  }
}

@media screen and (max-width: 979px) {
  .range-nodes-list__item {
    margin: 0 auto;
  }
}